import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { EmojiIcon } from '../EmojiIcon';
import styles from './MemoryAnswersV1.css';

const cx = classnames.bind(styles);

function MemoryAnswersV1({ answers, selectedId, onSelect, isWhite = false, spriteVersion }) {
    return (
        <ul className={styles.root}>
            {answers.map(answer => {
                const isChecked = selectedId === answer.id;

                return (
                    <li key={answer.id}>
                        <button
                            type='button'
                            className={cx('answer', { white: isWhite, checked: isChecked })}
                            onClick={onSelect(answer)}
                            aria-pressed={isChecked}
                        >
                            {Boolean(answer.icon && spriteVersion) && (
                                <EmojiIcon name={answer.icon} version={spriteVersion} />
                            )}
                            {answer.text}
                        </button>
                    </li>
                );
            })}
        </ul>
    );
}

MemoryAnswersV1.propTypes = {
    answers: PropTypes.array.isRequired,
    selectedId: PropTypes.number,
    onSelect: PropTypes.func.isRequired,
    isWhite: PropTypes.bool,
    spriteVersion: PropTypes.string
};

export {
    MemoryAnswersV1
};
